import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { usePage } from '@inertiajs/react';
import { Toaster, toast } from 'sonner';
import { useTheme } from '@/hooks/use-theme';
/**
 * Mensagens que o Laravel grava na sessão (toastr-success, toastr-error...)
 * e o primeiro erro de validação, mostrados como avisos.
 */
export function Flash() {
    const { flash, errors } = usePage().props;
    const { resolved } = useTheme();
    useEffect(() => {
        if (flash === null || flash === void 0 ? void 0 : flash.success)
            toast.success(flash.success);
        if (flash === null || flash === void 0 ? void 0 : flash.error)
            toast.error(flash.error);
        if (flash === null || flash === void 0 ? void 0 : flash.warning)
            toast.warning(flash.warning);
        if (flash === null || flash === void 0 ? void 0 : flash.info)
            toast.info(flash.info);
    }, [flash]);
    useEffect(() => {
        const first = errors ? Object.values(errors)[0] : null;
        if (first && !(flash === null || flash === void 0 ? void 0 : flash.error))
            toast.error(first);
    }, [errors]);
    return _jsx(Toaster, { position: "top-right", theme: resolved, closeButton: true, toastOptions: { className: 'font-sans' } });
}
